import React, { useMemo } from "react";
import ProfileInfoContent from "./ProfileInfoContent";
import { isPlaceholderEmail } from "../shared/utils/displayEmail";

function hasText(v) {
  if (v == null) return false;
  const s = String(v).trim();
  return s !== "" && s !== "—";
}

/**
 * Read-only profile: registration-form field layout (participant + parent/guardian).
 * Used by the ProfileInfo route and the participant Profile info modal.
 */
function ProfileInfoTabs({
  titleId,
  titleAction,
  /** When true, ModalShell already shows the title — skip duplicate Account chrome. */
  hidePageChrome = false,
  ...profileProps
}) {
  const hasParentInfo = useMemo(() => {
    const name = profileProps?.parentName != null ? String(profileProps.parentName).trim() : "";
    const emailRaw = profileProps?.parentEmail != null ? String(profileProps.parentEmail).trim() : "";
    const email = emailRaw && !isPlaceholderEmail(emailRaw) ? emailRaw : "";
    const phone = profileProps?.parentPhone != null ? String(profileProps.parentPhone).trim() : "";
    return !!(
      name ||
      email ||
      phone ||
      hasText(profileProps?.parentFirstName) ||
      hasText(profileProps?.parentLastName) ||
      hasText(profileProps?.parentPreferredName) ||
      hasText(profileProps?.parentGender) ||
      hasText(profileProps?.parentZipCode) ||
      hasText(profileProps?.parentHighestEducationLevel) ||
      hasText(profileProps?.parentHearAboutUs)
    );
  }, [
    profileProps?.parentName,
    profileProps?.parentEmail,
    profileProps?.parentPhone,
    profileProps?.parentFirstName,
    profileProps?.parentLastName,
    profileProps?.parentPreferredName,
    profileProps?.parentGender,
    profileProps?.parentZipCode,
    profileProps?.parentHighestEducationLevel,
    profileProps?.parentHearAboutUs,
  ]);

  return (
    <>
      {!hidePageChrome ? (
        <div style={{ marginBottom: "12px" }}>
          <div
            style={{
              fontSize: "12px",
              letterSpacing: "0.08em",
              textTransform: "uppercase",
              color: "#6b7280",
              marginBottom: "2px",
            }}
          >
            Account
          </div>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              gap: "12px",
              minWidth: 0,
            }}
          >
            <h2
              id={titleId}
              style={{
                margin: 0,
                fontSize: "1.15rem",
                fontWeight: 600,
                color: "#111827",
                minWidth: 0,
              }}
            >
              Profile info
            </h2>
            {titleAction}
          </div>
        </div>
      ) : null}

      <ProfileInfoContent {...profileProps} section="profile" showPageChrome={false} />

      {hasParentInfo ? (
        <div style={{ marginTop: "16px" }}>
          <div style={{ marginBottom: 8, fontSize: "0.875rem", fontWeight: 600, color: "#212529" }}>
            Parent / Guardian
          </div>
          <ProfileInfoContent {...profileProps} section="parent" showPageChrome={false} />
        </div>
      ) : null}
    </>
  );
}

export default ProfileInfoTabs;
